<template>
  <div style="width: auto">
    <template-list
      :auto-load-list="true"
      :model="$orderReviewTagGroup"
      :show-create-button="false"
      :key="templateListKey"
    >
      <template v-slot:actions>
        <v-btn
          class="rounded-lg"
          color="primary"
          depressed
          height="40"
          @click="openModal()"
        >
          <div class="text-none body-2 px-2">Создать</div>
        </v-btn>
      </template>
      <template v-slot:subactions> <Tabs /> </template>
      <template v-slot="{ object, index }">
        <v-col class="pa-0 link" @click="openModal(object)">
          <v-row no-gutters>
            <div class="ml-2 font-weight-medium text-truncate">
              {{ object.title }}
            </div>
          </v-row>
        </v-col>
      </template>
    </template-list>
    <v-dialog v-model="dialog" max-width="450">
      <v-card
        v-if="dialogItem"
        class="pa-5 rounded-lg"
        style="overflow-x: auto"
      >
        <div class="font-weight-bold mb-5">
          {{ dialogItem.id ? "Обновление группы" : "Создание группы" }}
        </div>
        <v-row class="ma-0">
          <v-text-field
            outlined
            dense
            hide-details
            v-model="dialogItem.title"
            label="Текст"
          />
          <v-checkbox hide-details label="Учитывать в ошибках сотрудников" v-model="dialogItem.is_worker_error" />
        </v-row>
        <v-row class="px-2 mt-5">
          <v-btn
            :disabled="!dialogItem.title"
            :loading="loading"
            color="primary"
            @click="saveDialogItem()"
            >Сохранить
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="dialogItem.id"
            :loading="loading"
            color="error"
            outlined
            @click="deleteDialogItem()"
            >Удалить
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import Tabs from "@/admin/views/orderReviewTags/Tabs.vue";

export default {
  name: "OrderReviewTagGroups",
  components: { Tabs },
  data: () => ({
    dialog: false,
    dialogItem: null,
    loading: false,
    templateListKey: 0
  }),
  methods: {
    setColor(e, item) {
      item.color = typeof e === "object" ? e.hexa : e;
    },
    openModal(_item) {
      let item = cloneDeep(_item);
      if (!item) item = cloneDeep(this.$orderReviewTagGroup.default);
      this.dialogItem = item;
      this.dialog = true;
    },
    saveDialogItem() {
      const create = !this.dialogItem.id;
      const item = this.dialogItem;
      this.loading = true;
      if (create) {
        this.$orderReviewTagGroup
          .create(item)
          .then((v) => {
            this.$orderReviewTagGroup.list.push(v);
            this.dialog = false;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$orderReviewTagGroup
          .update(item)
          .then((v) => {
            this.dialog = false;
            const index = this.$orderReviewTagGroup.list.findIndex(
              (el) => el.id === v.id
            );
            if (index > -1) this.$orderReviewTagGroup.list[index] = v;
            this.templateListKey++
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    deleteDialogItem() {
      this.loading = true;
      this.$orderReviewTagGroup
        .delete(this.dialogItem.id)
        .then(() => {
          this.dialog = false;
          const index = this.$orderReviewTagGroup.list.findIndex(
            (v) => v.id === this.dialogItem.id
          );
          if (index > -1) this.$orderReviewTagGroup.list.splice(index, 1);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) this.dialogItem = null;
    },
  },
};
</script>

<style scoped></style>